// extracted by mini-css-extract-plugin
module.exports = {"trending_wrapper":"Trending_trending_wrapper__C6X6Y","banner":"Trending_banner__knSVe","trending":"Trending_trending__q6GsS"};